import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";

export const INITIAL_STATE = {
    isSubmittingData: false,
    appointmentId: "",
    fullname: "",
    error: false,
    sellerReview: {},
    offeredPrice: 0,
    isSubmitted: false,
    showFeedbackScreen: false,
    userChoice: "",
    phone: "",
    showAsssuredPriceBanner: false,
    appointmentDetails: {},
    appointmentDetailsLoading: true,
    appointmentDetailsError: false,
    updateAppointmentBookingError: false,
    updateAppointmentBookingLoading: false,
    dateSlotLoading: false,
    dateSlotError: false,
    dateSlot: {},
    activeScreen: "SODetail",
    isPincodeGsEligble: false,
    isMMYVSgsEligible: false,
    isGsEligible: false,
    isSsr: false,
    registrationNo: null,
    leadCreatedType: "",
    marketPrice: null,
    c24mp: null,
    leadData: null,
    zone: null,
    locations: [],
    slots: null,
    isFetchingSlots: true,
    isSellOnline: false,
    applicableCityForSellOnline: [],
    userReport: null,
    hypothecation: null
};

export const setCarPriceDetail = (state = INITIAL_STATE, {
    fullname,
    appointmentId,
    sellerReview,
    offeredPrice,
    phone,
    marketPrice,
    c24mp
}) => {
    return {
        ...state,
        appointmentId,
        fullname,
        sellerReview,
        offeredPrice,
        phone,
        marketPrice,
        c24mp
    };
};

export const getDealerCarOfferPrice = (state = INITIAL_STATE, { offeredPrice, leadData }) => {
    return { ...state, offeredPrice, leadData };
};

export const fetchLeadDetailFailure = (state = INITIAL_STATE, {error}) => {
    return { ...state, error};
};

export const setIsSubmitted = (state = INITIAL_STATE, {isSubmitted}) => {
    return { ...state, isSubmitted};
};

export const setActiveScreen = (state = INITIAL_STATE, { screen }) => {
    return { ...state, activeScreen: screen };
};

export const setIsSubmittingQuestions = (state = INITIAL_STATE, { flag }) => {
    return { ...state, isSubmittingData: flag};
};

export const setIsPincodeGsEligble = (state = INITIAL_STATE, { flag }) => {
    return { ...state, isPincodeGsEligble: flag};
};

export const fetchAppointmentDetailsInit = (state = INITIAL_STATE, {appointmentDetailsLoading = true}) => {
    return { ...state, appointmentDetails: {}, appointmentDetailsLoading};
};

export const fetchAppointmentDetailSuccess = (state = INITIAL_STATE, {data}) => {
    return { ...state, appointmentDetails: data, appointmentDetailsLoading: false, updateAppointmentBookingLoading: false};
};

export const fetchAppointmentDetailFailure = (state = INITIAL_STATE, {error}) => {
    return { ...state, appointmentDetailsError: error, appointmentDetailsLoading: false};
};

export const fetchDateSlotInit = (state = INITIAL_STATE, {dateSlotLoading = true}) => {
    return { ...state, dateSlot: {}, dateSlotLoading, dateSlotError: false};
};

export const fetchDateSlotSuccess = (state = INITIAL_STATE, {data}) => {
    return { ...state, dateSlot: data || {}, dateSlotLoading: false, dateSlotError: false};
};

export const fetchDateSlotFailure = (state = INITIAL_STATE) => {
    return { ...state, dateSlot: {}, dateSlotLoading: false, dateSlotError: true};
};

export const updateAppointmentBookingFailure = (state = INITIAL_STATE, {error}) => {
    return { ...state, updateAppointmentBookingError: error, updateAppointmentBookingLoading: false};
};

export const updateAppointmentBookingInit = (state = INITIAL_STATE, {updateAppointmentBookingLoading = true}) => {
    return { ...state, updateAppointmentBookingLoading};
};

export const postOfferPriceInputSuccess = (state = INITIAL_STATE, {data = {}}) => {
    return { ...state, ...data};
};

export const setIsMMYVSElgiible = (state = INITIAL_STATE, { flag }) => {
    return { ...state, isMMYVSgsEligible: flag === "yes" ? true : false};
};

export const setIsGsEligible = (state = INITIAL_STATE, { flag }) => {
    return { ...state, isGsEligible: flag };
};

export const setOfferPrice = (state = INITIAL_STATE, { price }) => {
    return { ...state, offeredPrice: price };
};

export const updateSSR = (state = INITIAL_STATE, { flag }) => {
    return { ...state, isSsr: flag };
};

export const setRegistrationNo = (state = INITIAL_STATE, { number }) => {
    return { ...state, registrationNo: number };
};

export const setLeadCreatedType = (state = INITIAL_STATE, { leadType }) => {
    return { ...state, leadCreatedType: leadType };
};

export const fetchSlotsByLocationSuccess = (state = INITIAL_STATE, { zone, locations, slots }) => {
    return {
        ...state,
        zone,
        locations,
        slots,
        isLoading: false,
        isFetchingSlots: false
    };
};

export const fetchSlotsByLocationFailure = (state = INITIAL_STATE) => {
    return {
        ...state,
        zone: null,
        slots: null,
        locations: [],
        isLoading: false,
        isFetchingSlots: false
    };
};
export const setIsSellOnline = (state = INITIAL_STATE, { flag }) => {
    return { ...state, isSellOnline: flag };
};

export const setUserReport = (state = INITIAL_STATE, { report }) => {
    return { ...state, userReport: report };
};

export const setHypothecation = (state = INITIAL_STATE, { hypothecation }) => {
    return { ...state, hypothecation };
};

export const HANDLERS = {
    [Types.FETCH_LEAD_DETAIL_FAILURE]: fetchLeadDetailFailure,
    [Types.SET_IS_SUBMITTED]: setIsSubmitted,
    [Types.SET_CAR_PRICE_DETAIL]: setCarPriceDetail,
    [Types.SET_ACTIVE_SCREEN]: setActiveScreen,
    [Types.IS_SUBMITTING_DATA]: setIsSubmittingQuestions,
    [Types.IS_PINCODE_GS_ELIGBLE]: setIsPincodeGsEligble,
    [Types.FETCH_APPOINTMENT_DETAIL_SUCCESS]: fetchAppointmentDetailSuccess,
    [Types.FETCH_APPOINTMENT_DETAIL_FAILURE]: fetchAppointmentDetailFailure,
    [Types.FETCH_APPOINTMENT_DETAIL_INIT]: fetchAppointmentDetailsInit,
    [Types.UPDATE_APPOINTMENT_BOOKING_FAILURE]: updateAppointmentBookingFailure,
    [Types.FETCH_DATE_SLOTS_SUCCESS]: fetchDateSlotSuccess,
    [Types.FETCH_DATE_SLOTS_INIT]: fetchDateSlotInit,
    [Types.FETCH_DATE_SLOTS_FAILURE]: fetchDateSlotFailure,
    [Types.UPDATE_APPOINTMENT_BOOKING_INIT]: updateAppointmentBookingInit,
    [Types.POST_OFFER_PRICE_INPUT_SUCCESS]: postOfferPriceInputSuccess,
    [Types.SET_MMYVS_ELIGIBLITY]: setIsMMYVSElgiible,
    [Types.SET_IS_GS_ELIGIBLE]: setIsGsEligible,
    [Types.SET_OFFER_PRICE]: setOfferPrice,
    [Types.SET_SSR]: updateSSR,
    [Types.SET_REGISTRATION_NUMBER]: setRegistrationNo,
    [Types.SET_LEAD_CREATED_TYPE]: setLeadCreatedType,
    [Types.SET_REGISTRATION_NUMBER]: setRegistrationNo,
    [Types.GET_DEALER_CAR_PRICE]: getDealerCarOfferPrice,
    [Types.FETCH_OFFER_SLOTS_BY_LOCATIONS_SUCCESS]: fetchSlotsByLocationSuccess,
    [Types.FETCH_OFFER_SLOTS_BY_LOCATIONS_FAILURE]: fetchSlotsByLocationFailure,
    [Types.SET_IS_SELL_ONLINE_CITY]: setIsSellOnline,
    [Types.SET_USER_REPORT]: setUserReport,
    [Types.SET_HYPOTHECATION]: setHypothecation
};

export default createReducer(INITIAL_STATE, HANDLERS);
